
import React from "react";
import FAQItem from "./FAQItem";

const SupportSection: React.FC = () => {
  return (
    <section>
      <h2 className="text-2xl font-semibold mb-4 text-[#5F436C]">Support and Community</h2>
      
      <FAQItem question="How can I improve my remote viewing skills?">
        <p className="text-foreground">
          Our AI feedback system provides personalized guidance after each session, highlighting accuracy areas and suggesting improvement strategies. Regular practice with varied target types helps develop consistency.
        </p>
      </FAQItem>

      <FAQItem question="Can I get additional support?">
        <p className="text-foreground">
          Yes! Use our feedback form for questions, suggestions, or technical support. We're committed to helping you succeed in your remote viewing journey.
        </p>
      </FAQItem>

      <FAQItem question="Are there any restrictions on usage?">
        <p className="text-foreground">
          Our platform is intended for educational and personal development purposes. We ask users to practice responsibly and respect the serious nature of remote viewing research.
        </p>
      </FAQItem>
    </section>
  );
};

export default SupportSection;
